import MaintenanceMode from 'views/pages/maintenance-mode/MaintenanceMode';

export default MaintenanceMode;
